export default __webpack_public_path__ + "static/media/RightChoice.29aa3cbd.jpg";